import { Link } from 'react-router-dom';

const SUMMARY_ITEMS = [
  {
    icon: 'ri-seedling-line',
    plan: 'Essentiel',
    goal: 'Présence en ligne',
    desc: 'Lancez-vous avec un site professionnel et soyez visible immédiatement.',
    color: 'teal',
  },
  {
    icon: 'ri-user-star-line',
    plan: 'Pro',
    goal: 'Acquisition de clients',
    desc: 'Attirez de nouveaux clients avec un site optimisé pour la conversion.',
    color: 'emerald',
  },
  {
    icon: 'ri-line-chart-line',
    plan: 'Premium',
    goal: 'Croissance maximale',
    desc: 'Dominez votre marché avec un site haute performance et une visibilité maximale.',
    color: 'amber',
  },
];

const REASSURANCES = [
  { icon: 'ri-shield-check-line', text: 'Accompagnement personnalisé' },
  { icon: 'ri-timer-flash-line', text: 'Livraison en 7 jours max' },
  { icon: 'ri-headphone-line', text: 'Support réactif inclus' },
  { icon: 'ri-secure-payment-line', text: 'Paiement sécurisé' },
  { icon: 'ri-award-line', text: '100% sur mesure' },
  { icon: 'ri-refresh-line', text: 'Sans engagement' },
];

export default function OffresSummary() {
  return (
    <>
      {/* Résumé des objectifs */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-4xl font-black text-slate-900 mb-3">
              Quelle offre est <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">faite pour vous ?</span>
            </h2>
            <p className="text-sm sm:text-base text-slate-500 max-w-xl mx-auto">
              Chaque offre est conçue pour un objectif précis. Choisissez selon votre ambition.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 mb-14">
            {SUMMARY_ITEMS.map((item) => {
              const isEmerald = item.color === 'emerald';
              const isAmber = item.color === 'amber';
              return (
                <div
                  key={item.plan}
                  className={`rounded-3xl p-7 sm:p-8 border-2 text-center transition-all duration-300 hover:-translate-y-1 ${
                    isEmerald
                      ? 'bg-emerald-50 border-emerald-200'
                      : isAmber
                      ? 'bg-amber-50 border-amber-200'
                      : 'bg-teal-50 border-teal-100'
                  }`}
                >
                  <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4 ${
                    isEmerald ? 'bg-emerald-100' : isAmber ? 'bg-amber-100' : 'bg-teal-100'
                  }`}>
                    <i className={`${item.icon} text-2xl ${
                      isEmerald ? 'text-emerald-600' : isAmber ? 'text-amber-600' : 'text-teal-600'
                    }`}></i>
                  </div>
                  <span className={`inline-block text-xs font-black px-3 py-1 rounded-full mb-3 ${
                    isEmerald
                      ? 'bg-emerald-200 text-emerald-800'
                      : isAmber
                      ? 'bg-amber-200 text-amber-800'
                      : 'bg-teal-200 text-teal-800'
                  }`}>
                    {item.plan}
                  </span>
                  <h3 className="text-lg sm:text-xl font-black text-slate-900 mb-2">{item.goal}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{item.desc}</p>
                </div>
              );
            })}
          </div>

          {/* Réassurances */}
          <div className="bg-slate-50 rounded-3xl p-7 sm:p-10 border border-slate-100">
            <h3 className="text-center text-base sm:text-lg font-black text-slate-900 mb-6">
              Pourquoi choisir <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">UzunDigital</span> ?
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {REASSURANCES.map((r, i) => (
                <div key={i} className="flex items-center space-x-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-emerald-100 flex-shrink-0">
                    <i className={`${r.icon} text-emerald-600 text-base`}></i>
                  </div>
                  <span className="text-sm font-semibold text-slate-700">{r.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/86441d5d5dcfadd36284e3f9089c8789.jpg"
            alt=""
            className="w-full h-full object-cover object-center"
            loading="lazy"
            width="1440"
            height="600"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md border border-white/20 text-white px-5 py-2.5 rounded-full text-xs sm:text-sm font-bold mb-7">
            <i className="ri-flashlight-line text-emerald-400 text-base"></i>
            <span>PASSEZ À L'ACTION</span>
          </div>

          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-4 sm:mb-6 leading-tight">
            Votre site livré en
            <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent"> 7 jours</span>
            <br className="hidden sm:block" />
            <span> — Démarrez maintenant</span>
          </h2>
          <p className="text-sm sm:text-lg text-white/70 mb-8 max-w-xl mx-auto">
            Devis 100% gratuit · Réponse sous 24h · Accompagnement personnalisé
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/demande-devis"
              className="group inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg font-black shadow-xl shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <span>Commencer maintenant</span>
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </Link>
            <Link
              to="/demande-devis"
              className="inline-flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-md border border-white/30 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <i className="ri-calendar-line text-base"></i>
              <span>Prendre rendez-vous</span>
            </Link>
          </div>

          <p className="mt-6 text-white/40 text-xs sm:text-sm font-medium">
            Sans engagement · Paiement sécurisé · Accompagnement inclus
          </p>
        </div>
      </section>
    </>
  );
}
